import { AudioRecordingConfig, AudioAnalyzerConfig } from './types';

// Mono speech at 128 kbps is transparent for ASR in both Opus and AAC-LC
// (Safari); an explicit value removes dependence on browser defaults.
export const AUDIO_BITS_PER_SECOND = 128_000;

export const DEFAULT_RECORDING_CONFIG: AudioRecordingConfig = {
  chunkInterval: 15000, // 15 seconds (matches transcriptor)
  mimeType: 'audio/webm',
  audioBitsPerSecond: AUDIO_BITS_PER_SECOND,
  maxRetries: 3, // Not used anymore - uploader has infinite retry
  retryDelay: 1000, // 1 second
};

// Explicit opus first: the generic 'audio/webm' lets the browser pick any
// audio codec, while opus is what the backend ASR pipeline expects.
export const SUPPORTED_MIME_TYPES = [
  'audio/webm;codecs=opus',
  'audio/ogg;codecs=opus',
  'audio/webm',
  'audio/mp4',
];

export const AUDIO_ANALYZER_CONFIG: AudioAnalyzerConfig = {
  fftSize: 256,
  smoothingTimeConstant: 0.8,
  minDecibels: -90,
  maxDecibels: -10,
};

export const AUDIO_LEVEL_POLL_INTERVAL_MS = 500;

// 0-100 time-domain RMS scale: digital silence (dead or OS-muted mic) reads
// ~0, while any live microphone's noise floor exceeds this.
export const SILENCE_RMS_THRESHOLD = 0.5;

// Long enough not to fire on natural pauses in the conversation.
export const AUDIO_ISSUE_SILENCE_MS = 20_000;

export const ACTIVITY_PING_INTERVAL_MS = 10000; // 10 seconds

// devicechange is unreliable on some mobile browsers, so the presence watcher
// also polls (same fallback as the pre-recording microphone modal).
export const DEVICE_PRESENCE_POLL_INTERVAL_MS = 2000;

export const RETRY_CONFIG = {
  initialDelayMs: 1000,
  maxDelayMs: 30000,
  backoffMultiplier: 2,
};

export const NON_RETRYABLE_STATUS_CODES = [400, 401, 403, 404, 409];

export const ERROR_CODES = {
  PERMISSION_DENIED: 'PERMISSION_DENIED',
  DEVICE_NOT_FOUND: 'DEVICE_NOT_FOUND',
  RECORDING_FAILED: 'RECORDING_FAILED',
  CHUNK_SEND_FAILED: 'CHUNK_SEND_FAILED',
  NO_BROWSER_SUPPORT: 'NO_BROWSER_SUPPORT',
  INVALID_STATE: 'INVALID_STATE',
} as const;
